module.exports = __webpack_public_path__ + "static/media/app_guide.04744b64.jpg";